import {
  CsvFormat,
  SortDirection,
} from '@mesa-labs/mesa-api/dist/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PaginationLimits } from './invoices';

export type AdjustmentsState = {
  page: number;
  limit: { key: string; value: number };
  total?: number;
  searchTerm?: string;
  sortField?: string;
  sortDirection: SortDirection;
  exportFormat: CsvFormat;
};

const initialState: AdjustmentsState = {
  page: 1,
  limit: PaginationLimits[0],
  total: undefined,
  searchTerm: undefined,
  sortField: 'generalLedgerDate',
  sortDirection: SortDirection.DESCENDING,
  exportFormat: CsvFormat.MESA_CSV_FORMAT,
};

const adjustmentsSlice = createSlice({
  name: 'adjustments',
  initialState,
  reducers: {
    updatePage(state: AdjustmentsState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    updateLimit(state: AdjustmentsState, action: PayloadAction<{ key: string; value: number }>) {
      state.limit = action.payload;
    },
    updateTotal(state: AdjustmentsState, action: PayloadAction<number>) {
      state.total = action.payload;
    },
    updateSearchTerm(state: AdjustmentsState, action: PayloadAction<string>) {
      state.searchTerm = action.payload;
    },
    updateSortField(state: AdjustmentsState, action: PayloadAction<string>) {
      state.sortField = action.payload;
    },
    updateSortDirection(state: AdjustmentsState, action: PayloadAction<SortDirection>) {
      state.sortDirection = action.payload;
    },
    updateExportFormat(state: AdjustmentsState, action: PayloadAction<CsvFormat>) {
      state.exportFormat = action.payload;
    },
  },
});

export const {
  updatePage,
  updateLimit,
  updateTotal,
  updateSearchTerm,
  updateSortField,
  updateSortDirection,
  updateExportFormat,
} = adjustmentsSlice.actions;
export default adjustmentsSlice.reducer;
